<template>
  <div>
    <ordenar-reglamento
      :listReglamento="listMotivosModal"
      @ordenar="ordenarMotivos($event)"
      @ordenarReglamento="recargarReglamento"
    ></ordenar-reglamento>
    <b-card no-body class="p-1">
      <b-overlay :show="showLoading" rounded="sm">
        <b-row>
          <b-col
            md="3"
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA ||
                USER().rol === ROLES.SANCIONES ||
                USER().rol === ROLES.TESORERIA
            "
          >
            <v-select
              :options="listCampeonatos"
              placeholder="Sel. Camp"
              :clearable="false"
              v-model="campeonatoSeleccionado"
            />
          </b-col>
          <b-col md="5">
            <b-button
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.SANCIONES
              "
              v-b-tooltip.hover.v-primary
              title="Agregar "
              variant="flat-primary"
              class="btn-icon"
              @click="showNewMotivoOnly"
            >
              <feather-icon size="14" icon="PlusIcon" />
            </b-button>
            <b-button
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.SANCIONES
              "
              v-b-tooltip.hover.v-primary
              title="Ordenar Reglamento"
              variant="flat-primary"
              class="btn-icon"
              @click="openOrdenar"
            >
              <feather-icon size="14" icon="BarChart2Icon" />
            </b-button>
          </b-col>
          <b-col md="4" class="d-flex align-items-center">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-0"
              placeholder="Buscar..."
            />
          </b-col>
        </b-row>

        <b-table
          ref="refInvoiceListTable"
          :fields="tableColumns"
          :items="listMotivosFilter"
          primary-key="id"
          show-empty
          responsive
          small
          empty-text="No se encontraron datos"
          class="position-relative mt-1"
          style="max-height:60vh"
          :sticky-header="true"
          :no-border-collapse="true"
        >
          <!-- Column: Player -->
          <template #cell(sancion)="data">
            <div style="width: 40vw; ">
              <span class="font-weight-bold d-block text-nowrap">
                {{ data.item.motivo }}
              </span>
              <span class="text-muted" style="color:#9d9da0; font-size:13px">{{
                data.item.detalle
              }}</span>
            </div>
          </template>

          <template #cell(valor)="data">
            <template>
              <b-badge pill style="font-size:13px">
                {{ data.item.valor }}
              </b-badge>
            </template>
          </template>

          <template #cell(tipo_partido)="data">
            <template>
              <b-badge
                v-if="data.item.tipo_partido == 's'"
                variant="warning"
                style="font-size:13px"
              >
                partido {{ data.item.id_opcion_baja }}
                <span v-if="data.item.id_opcion_baja == 1">(Modifica)</span>
                <span v-if="data.item.id_opcion_baja == 2">(No Modifica)</span>
              </b-badge>
            </template>
          </template>

          <template #cell(total_partidos)="data">
            <template>
              <div style=" text-align: center;">
                <b-badge
                  style="font-size:16px;"
                  pill
                  variant="warning"
                  v-if="data.item.total_partidos !== null"
                >
                  {{ data.item.total_partidos }}
                </b-badge>
              </div>
            </template>
          </template>

          <!-- Column: Actions -->
          <template #cell(opc)="data">
            <div class="text-nowrap">
              <feather-icon
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
                @click="showNewMotivoDetalle(data.item)"
              />
              <feather-icon
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.SANCIONES
                "
                icon="Trash2Icon"
                size="16"
                class="mx-1 cursor-pointer"
                @click="showModalConfirmacion(data.item)"
              />
            </div>
          </template>
        </b-table>
      </b-overlay>
      <b-modal
        id="modal-multi-3"
        size="sm"
        title="Confirmación"
        ok-only
        ok-title="Accept"
        v-model="showEliminarReglamento"
      >
        <b-card-text class="my-1">
          ¿ Deseas Eliminar el árticulo ?
        </b-card-text>
        <template #modal-footer>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="showEliminarReglamento = false"
          >
            Cancelar
          </b-button>
          <b-button
            v-if="!showLoadingEliminar"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="deleteEspecial"
          >
            Aceptar
          </b-button>
          <div v-if="showLoadingEliminar" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
        </template>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  BCard,
  BOverlay,
  BTable,
  // BMedia,
  BBadge,
  BButton,
  VBTooltip,
  BModal,
  BCardText,
  BSpinner,
  BFormInput,
  BRow,
  BCol,
  //   BIconLayers,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import ordenarReglamento from './ModalOrdenar.vue'
import {
  URL,
  USER,
  ROLES,
  // INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  // UPDATE_DATA_PLAYER,
  // ESTADO_JUGADOR,
} from '../../utils/variables'
// import modalLog from './LogDetalle.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    // BMedia,
    BBadge,
    BButton,
    BModal,
    BCardText,
    BSpinner,
    BFormInput,
    BRow,
    BCol,
    vSelect,
    ordenarReglamento,
    // modalLog,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    listMotivos: Array,
    listCampeonatos: Array,
    showLoading: Boolean,
    seleccionado: Object,
  },
  setup(props, { emit }) {
    // const showLoading = ref(false)
    const tableColumns = [
      { key: 'sancion', label: 'Articulo', sortable: true },
      { key: 'valor', label: 'Valor $', sortable: true },
      { key: 'tipo_partido', label: 'Tipo', sortable: true },
      { key: 'total_partidos', label: '# Partidos', sortable: true },
      // { key: 'estado_jug', sortable: true },
      { key: 'opc' },
    ]
    const { postApi } = apiCall()
    // const listSancionados = ref([])
    const dataLog = ref(null)
    const showEliminarReglamento = ref(false)
    const showLoadingEliminar = ref(false)
    const motivoElegido = ref(null)
    const searchQuery = ref('')
    const listMotivosModal = ref([])
    const campeonatoSeleccionado = computed({
      get: () => props.seleccionado,
      set: value => {
        // props.isManualProp = value
        emit('change', value)
      },
    })
    function getDetalle(item) {
      // console.log(props)
      emit('getDetalleEspecial', item)
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', true)
    }

    function ordenarMotivos(list) {
      listMotivosModal.value = list
    }
    function recargarReglamento() {
      emit('recargarReglamento')
    }
    const listMotivosFilter = computed(
      () =>
        // eslint-disable-next-line
        props.listMotivos.filter(
          // eslint-disable-next-line
          player =>
            // eslint-disable-next-line
            player.motivo
              .toLowerCase()
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.detalle
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase())
          // eslint-disable-next-line
        )
      // eslint-disable-next-line
    )
    function openOrdenar() {
      // console.log(props)
      listMotivosModal.value = [...listMotivosFilter.value]
      store.commit('someVariables/UPDATE_SHOW_ORDENAR_REGLAMENTO', true)
    }
    function showNewMotivoOnly() {
      emit('onlyMotivo')
    }
    function showNewMotivoDetalle(item) {
      emit('onlyDetalle', item)
    }
    // const { getApi } = apiCall()
    // async function getEspeciales(idTorneo) {
    //   listSancionados.value = []
    //   showLoading.value = true
    //   const path = `ApiSanciones/getSancionesEspeciales/${idTorneo}`
    //   const data = await getApi(URL, path)
    //   listSancionados.value = data.data
    //   showLoading.value = false
    // }
    // onMounted(() => {
    //   getEspeciales(
    //     // eslint-disable-next-line
    //     store.getters['someVariables/getTorneoSeleccionado'].id_torneo
    //   )
    //   // console.log(refP.value)
    // })
    function changeCampeonato(item) {
      emit('change', item)
    }

    function showModalConfirmacion(item) {
      showEliminarReglamento.value = true
      motivoElegido.value = item
      // console.log(motivoElegido.value)
    }
    async function deleteEspecial() {
      // console.log(motivoElegido)
      showLoadingEliminar.value = true
      const path = 'ApiSanciones/deleteMotivoReglamento'
      const data = {
        idMotivo: motivoElegido.value.id_motivo_sancion,
        idUsuario: USER().id_usuario,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        dataMovimiento: `Elimina el articulo ${motivoElegido.value.motivo} id - ${motivoElegido.value.id_motivo_sancion}`,
      }
      const response = await postApi(URL, path, data)
      // console.log(response)
      if (response == null) {
        emit('showError')
      } else if (response.flag === 'si') {
        emit('recargaMotivos')
      }
      showEliminarReglamento.value = false
      showLoadingEliminar.value = false
    }

    return {
      // showLoading,
      tableColumns,
      // listSancionados,
      // modalLog,
      dataLog,
      avatarText,
      getDetalle,
      ROLES,
      USER,
      showEliminarReglamento,
      showLoadingEliminar,
      showModalConfirmacion,
      deleteEspecial,
      showNewMotivoOnly,
      searchQuery,
      listMotivosFilter,
      changeCampeonato,
      campeonatoSeleccionado,
      showNewMotivoDetalle,
      openOrdenar,
      ordenarMotivos,
      listMotivosModal,
      recargarReglamento,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
